import React, { useMemo } from "react"
import TableContainer from "components/Common/TableContainer"
import { Link } from "react-router-dom"
import avatar from "../../../assets/images/avatar.png"
import eye from "../../../assets/images/icons/eye.svg"
import { UncontrolledTooltip } from "reactstrap"
import { getAdminsStatus, getTableSortingHeaderIcon } from "helpers/common"
import { usePermission } from "hooks/usePermission"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"
import { useSelector } from "react-redux"

const UserSearchResults = ({ data = [], close }) => {
  const { hasAnyPermission, hasPermission } = usePermission()
  const { userType } = useSelector((state) => state.user)

  const columns = useMemo(() => {
    const data = [
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(
            column,
            userType === "INVESTOR" ? "User Details" : "Investor Details"
          ),
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <DefaultAvatar
            email={row?.original.email}
            name={row?.original.name}
          />
        ),
      },
      {
        header: () => <div className="flex items-center gap-2">Date</div>,
        accessorKey: "formatted_created_at",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <div className="code-status">
            {getAdminsStatus(row?.original.status)}
          </div>
        ),
      },

      {
        id: "actions",
        header: "Actions",
        cell: ({ row }) => {
          const editTooltip = `editTooltip-${row?.original.id}`

          return (
            <>
              {userType === "INVESTOR" ? (
                <div className="d-flex justify-content-center align-items-center gap-3">
                  {hasPermission("USERS_UPDATE") && (
                    <>
                      <div className="action-view">
                        <Link
                          to={`/manage-users/edit/${row?.original.id}`}
                          onClick={close}
                        >
                          <img src={edit} id={editTooltip} alt="" />
                          <UncontrolledTooltip
                            placement="top"
                            target={editTooltip}
                          >
                            View
                          </UncontrolledTooltip>
                        </Link>
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center gap-3">
                  <div className="action-view">
                    <Link
                      to={`/investor-management/view/${row?.original.id}`}
                      onClick={close}
                    >
                      <img src={eye} id={editTooltip} alt="" />
                      <UncontrolledTooltip placement="top" target={editTooltip}>
                        View
                      </UncontrolledTooltip>
                    </Link>
                  </div>
                </div>
              )}
            </>
          )
        },
      },
    ]

    if (userType === "investor") {
      const canAccess = hasAnyPermission(["USERS_UPDATE"])
      if (canAccess) return data
      return data.filter((item) => item.id !== "actions")
    }
    return data
  }, [hasAnyPermission])

  return (
    <>
      <TableContainer
        filters={{ page: 1, pageSize: 100 }}
        columns={columns}
        data={data}
        count={data.length}
        isPagination={false}
        isCustomPageSize={false}
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers"
        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
      />
    </>
  )
}

export default UserSearchResults
